import { StaticTranslationCsvManager } from './StaticTranslationsCsvManager';
import React, { useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useGlobalizationContext, useTranslation, useGetLocales } from '@cs-cms/state-management';

interface LocaleOption {
  id: number;
  name: string;
  text: string;
}

export const StaticTranslationsManagement: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const [activeLocaleNumber, setActiveLocaleNumber] = useState(0);
  const { data: locales } = useGetLocales();

  const availableLocales = locales ?? [];
  const safeActiveLocaleNumber =
    availableLocales.length > 0 && activeLocaleNumber >= availableLocales.length ? 0 : activeLocaleNumber;
  const activeLocale = availableLocales[safeActiveLocaleNumber];
  const localeOptions: LocaleOption[] = availableLocales.map(locale => ({
    id: locale.id,
    name: locale.name,
    text: translate(`custom.topBar.language.${locale.name}`)
  }));
  const activeLocaleOption = localeOptions[safeActiveLocaleNumber];

  const handleLocaleChange = (event: any) => {
    const value = event.target.value;
    const localeIndex = availableLocales.findIndex(locale => locale.id === value.id);
    if (localeIndex !== -1) {
      setActiveLocaleNumber(localeIndex);
    }
  };

  return (
    <>
      <div className="translationsTitleContainer">
        <h1>{translate('custom.settings.adminCenter.translationManagement.staticTranslations.title')}</h1>
        <DropDownList
          data={localeOptions}
          label={translate('custom.topBar.language.title')}
          value={activeLocaleOption}
          onChange={handleLocaleChange}
          textField="text"
          dataItemKey="id"
          size="medium"
          className="translationsLocaleDropdown"
          disabled={availableLocales.length === 0}
        />
      </div>
      <p>{translate('custom.settings.adminCenter.translationManagement.staticTranslations.description')}</p>

      <StaticTranslationCsvManager activeLocale={activeLocale} />
    </>
  );
};
